<template>
<div class="box" style="margin-bottom:50px">
  <article class="media">
    <div class="media-content">
      <div class="content">
        <h3><strong>Informações do evento: {{event.name}} </strong></h3>
        <p style="margin-bottom:20px">
          <b style="font-weight:bold">Data:</b> {{this.start_date.getDate()}} a {{this.end_date.getDate()}} de {{this.month_event}}<br><br>
          <b style="font-weight:bold">Horário:</b> {{this.start_date.getHours()}}hs as {{this.end_date.getHours()}}hs<br><br>
          <b style="font-weight:bold">Local:</b> {{event.address}}<br><br>
          <b style="font-weight:bold">LEIA AS INFORMAÇÕES ABAIXO:</b><br>
          <p id="info"></p><br>
        </p>
      </div>
    </div>
  </article>
</div>
</template>

<script>
export default {
  data() {
    return {
      event: {},
      start_date: new Date(),
      end_date: new Date(),
      month_event: null
    }
  },
  mounted: function() {
    this.getEvent()
    this.formatFullDates()
    this.embedDescription()
  },
  methods: {
    getEvent() {
      this.event = JSON.parse(localStorage.getItem('event'))
    },
    formatFullDates() {
      this.start_date = new Date(...this.event.start_date.split('-').map((item, indice) => item - indice % 2))
      this.end_date = new Date(...this.event.end_date.split('-').map((item, indice) => item - indice % 2))
      this.month_event = this.start_date.toLocaleString('pt-BR', {
        month: "long"
      }).replace(/\b\w/g, l => l.toUpperCase())
      this.start_date.setHours(...this.event.start_hour.split(/[\:/\-/\'UTC'\' ']/).splice(3, 5))
      this.end_date.setHours(...this.event.end_hour.split(/[\:/\-/\'UTC'\' ']/).splice(3, 5))
    },
    embedDescription() {
      document.querySelector("#info").innerHTML = this.event.description
    }
  }
}
</script>



// WEBPACK FOOTER //
// About.vue?6b90be32